<template>
  <div id="header">
    <div class="headerSet">
      <div class="headerCenter">
        <div class="headerTop screenWidth">
          <div class="d-flex align-items-center">
            <img class="brand" @click="ToHomePage" img src="../../assets/img/Logo_TAX.png" />
            <div class="line"></div>

            <SelectCompany v-if="isRenderSelectCompany" />
          </div>
          <div class="d-flex align-items-center">
            <!-- <p>video</p>
            <div class="line"></div> -->
            <div class="nav-tools">
              <ul>
                <li>
                  <Notification />
                </li>
                <li><UserManual /></li>
                <li>
                  <ApplicationStore v-if="isConnectWithPeak" />
                </li>
              </ul>
            </div>
            <div class="line"></div>
            <SwitchlangHeader class="ml-3" />
            <DropdownUser />
          </div>
        </div>
      </div>
      <div class="headerCenter">
        <div class="herderMenuBar screenWidth">
          <MainNavbar />
        </div>
      </div>
      <transition>
        <div v-show="scrollOver" class="fixHeader">
          <div class="headerCenter">
            <div class="screenWidth">
              <MainNavbar />
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script lang="ts">
import { LoadingStatusType } from "@/enums/enums";
import { MerchantId } from "@/helper/userHelper";
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import ApplicationStore from "./ApplicationStore.vue";
import DropdownUser from "./DropdownUser.vue";
import MainNavbar from "./MainNavbar.vue";
import Notification from "./Notification.vue";
import SelectCompany from "./SelectCompany.vue";
import SwitchlangHeader from "./SwitchlangHeader.vue";
import UserManual from "./UserManual.vue";

const StoreSetting = namespace("Setting");
const StoreLogIn = namespace("LogIn");

@Component({
  components: { MainNavbar, SwitchlangHeader, ApplicationStore, DropdownUser, SelectCompany, Notification, UserManual },
})
export default class Header extends Vue {
  private isConnectWithPeak: any = false;

  private scrollOver = false;
  private lastScrollTop = 0;
  private isRenderSelectCompany = true;

  @StoreLogIn.Getter
  private getMerchantByResetCacheLoadingStatus!: LoadingStatusType;

  @StoreSetting.Getter
  private getSettingConnectPeakModel!: any;

  mounted() {
    window.addEventListener("scroll", this.HandleScroll);
  }

  @Watch("getMerchantByResetCacheLoadingStatus")
  getMerchantByResetCacheLoadingStatusChange(newValue: LoadingStatusType) {
    if (newValue === LoadingStatusType.Success) {
      this.isRenderSelectCompany = false;
      setTimeout(() => {
        this.isRenderSelectCompany = true;
      }, 0);
    }
  }

  public HandleScroll() {
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (currentScrollTop > this.lastScrollTop) {
      // downscroll code
      this.scrollOver = false;
    } else if (currentScrollTop < this.lastScrollTop) {
      // upscroll code
      this.scrollOver = window.scrollY > 110;
    }
    this.lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
  }

  created() {
    if (this.getSettingConnectPeakModel) {
      this.isConnectWithPeak = this.getSettingConnectPeakModel.isPeakTaxConnected;
    }
  }

  public ToHomePage() {
    this.$router.push({
      name: "home",
      query: { emi: MerchantId().PeakEncryption() },
    });
  }
}
</script>

<style lang="scss" scoped>
#header {
  .headerSet {
    background: -webkit-linear-gradient(left, #6c6df2 0%, #44e5e6 100%);
    background: linear-gradient(to right, #6c6df2 0%, #44e5e6 100%);
    height: 133px;
    @media only screen and (max-width: 1280px) {
      width: 1280px;
    }
    .headerCenter {
      @include screenCenter;
    }
  }
  .headerTop {
    padding-top: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .line {
      width: 1px;
      height: 30px;
      background: white;
      margin-left: 15px;
    }
    .brand {
      h1 {
        @include font(lig);
        color: white;
      }
      cursor: pointer;
      height: 40px;
    }
    .nav-tools {
      ul {
        list-style-type: none;
        margin: 0px;
        padding-left: 8px;
        display: flex;
        align-items: center;
        li {
          margin-left: 5px;
          margin-right: 5px;
        }
        .comment {
          height: 30px;
          width: 30px;
          a {
            margin-top: 6px;
            margin-left: 7px;
          }
        }
        a {
          color: white !important;
        }
      }
    }
  }
  .herderMenuBar {
    padding-top: 5px;
  }
  .fixHeader {
    position: fixed;
    top: 0;
    width: 100%;
    background: white;
    @include shadowboxLv2;
    z-index: 100;
    &::v-deep {
      .mainNavBar {
        margin-top: 0;
        box-shadow: unset;
        ul {
          li {
            a {
              > div {
                padding: 16px 10px;
              }
            }
          }
          .lockMenu {
            > div:first-child {
              padding: 16px 0px;
            }
          }
        }
      }
    }
  }
}
</style>
